import { RootLayout } from "@neu/libui";

import { pbmPortalTopNavModules } from "./pbmPortalTopNav";

export const PbmPortalLayout = () => (
	<RootLayout
		topBarProps={{
			navModules: pbmPortalTopNavModules,
			logoTitle: "PBM Portal",
		}}
	/>
);
